import { render, staticRenderFns } from "./CookiesAgreement.vue?vue&type=template&id=173c0f30&scoped=true&"
import script from "./CookiesAgreement.vue?vue&type=script&lang=js&"
export * from "./CookiesAgreement.vue?vue&type=script&lang=js&"
import style0 from "./CookiesAgreement.vue?vue&type=style&index=0&id=173c0f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c0f30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
